import React, { memo, useContext } from 'react'
import './Admin.css'
import '../body/Body.scss'
import { SPContext } from '../../SPContext'
import Filter from '../filter/Filter'
import PageLoading from '../helpers/PageLoading'

const Admin = memo(
  ({
    uri,
    events,
    setEvents,
    users,
    eventGoingPost,
    eventLikePost,
    user_id,
    categories,
    travels,
    locations,
    token,
    event_types,
    authStatus,
    appStatus,
    isLoggedIn,
    isAdmin,
    inAdminPage,
    setInAdminPage,
  }) => {
    return (
      <div
        className={
          'app' +
          ((authStatus === 'auth_checked' && !isLoggedIn && ' login') || '') +
          (((authStatus === 'waiting_for_auth_check' ||
            (isLoggedIn && appStatus !== 'ready')) &&
            ' loading') ||
            '')
        }
      >
        {(isLoggedIn && appStatus === 'ready' && isAdmin && (
          <section className='sp-body'>
            {((authStatus === 'waiting_for_auth_check' ||
              (isLoggedIn && appStatus !== 'ready')) && <PageLoading />) ||
              null}
            <React.Fragment>
              <Filter />
            </React.Fragment>
          </section>
        )) ||
          null}

        {isLoggedIn && appStatus === 'ready' && !isAdmin && (
          <React.Fragment>
            <div className='sp-admin-not-allowd'>Access not allowed!</div>
          </React.Fragment>
        )}
      </div>
    )
  },
)

const AdminContainer = props => {
  const {
    uri,
    events,
    setEvents,
    users,
    eventGoingPost,
    eventLikePost,
    user_id,
    categories,
    locations,
    token,
    event_types,
    authStatus,
    appStatus,
    isLoggedIn,
    isAdmin,
    inAdminPage,
    setInAdminPage,
  } = useContext(SPContext)
  return (
    <Admin
      uri={uri}
      events={events}
      setEvents={setEvents}
      users={users}
      eventGoingPost={eventGoingPost}
      eventLikePost={eventLikePost}
      user_id={user_id}
      categories={categories}
      locations={locations}
      token={token}
      event_types={event_types}
      authStatus={authStatus}
      appStatus={appStatus}
      isLoggedIn={isLoggedIn}
      isAdmin={isAdmin}
      inAdminPage={inAdminPage}
      setInAdminPage={setInAdminPage}
      {...props}
    />
  )
}

export default AdminContainer
